export default class QuestionnaireType {}

QuestionnaireType.FleaAndTick = 'FLEA_AND_TICK';
